import { Button } from '@/components/ui/button'

export function AuthorizationUnavailable({ retry }: { retry: () => void }) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-muted/20 px-6">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-semibold">Access information is unavailable</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Protected pages remain closed until your access can be verified.
        </p>
        <Button className="mt-6" variant="outline" onClick={retry}>
          Try again
        </Button>
      </div>
    </main>
  )
}
